export default "__VITE_ASSET__CDkbIMA___"